import { render, staticRenderFns } from "./SlideSearchNoResult.vue?vue&type=template&id=3b6128de&scoped=true&"
import script from "./SlideSearchNoResult.vue?vue&type=script&lang=js&"
export * from "./SlideSearchNoResult.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearchNoResult.vue?vue&type=style&index=0&id=3b6128de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6128de",
  null
  
)

export default component.exports